// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","PanelFooter":"beb_a bhs_b bhs_tu bhs_qz bhs_ra bhs_uo","PanelFooter--link":"beb_b"};